<template>
  <v-form v-model="valid" :ref="$options.name">
    <h5>{{ $t('registration.subtitles.additional') }}</h5>
    <v-layout wrap row>
      <v-flex xs12>
        <v-radio-group
          :label="$t('registration.playerForm.gender')+':'"
          ref="gender"
          :value="value.gender"
          @change="update('gender', $refs.gender.lazyValue)"
          :rules="genderRules"
          row
          mandatory
        >
          <v-radio
            :label="$t('registration.playerForm.male')"
            value="M"
          ></v-radio>
          <v-radio
            :label="$t('registration.playerForm.female')"
            value="F"
          ></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex xs12 sm6 class="pr-2">
        <v-text-field
          :label="$t('registration.playerForm.email')"
          ref="email"
          :value="value.email"
          @input="update('email', $refs.email.lazyValue)"
          :rules="emailRules"
          required
        />
      </v-flex>
      <v-flex xs12 sm6 class="pl-2">
        <v-text-field
          v-model="emailConfirm"
          :label="$t('registration.playerForm.email_confirm')"
          :rules="emailConfirmRules"
          required
        />
      </v-flex>
      <v-flex xs12 sm6>
        <v-text-field
          :label="$t('registration.playerForm.phone')"
          ref="phone"
          :value="value.phone"
          @input="update('phone', $refs.phone.lazyValue)"
          :rules="phoneRules"
          :mask="phoneMask"
          required
        />
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
export default {
  name: 'PlayerAdditional',
  props: {
    value: Object
  },
  data() {
    return {
      valid: false,
      emailConfirm: '',
      genderRules: [ (v) => !!v || this.$t('validation.genderRequired') ],
      emailRules: [(v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t('validation.emailValid')],
      emailConfirmRules: [ (v) => v === this.value.email || this.$t('validation.emailConfirm') ],
      phoneRules: [ (v) => !!v || this.$t('validation.phoneRequired') ]
    }
  },
  computed: {
    phoneMask () {
      switch (this.value.country || this.teamCountry) {
        case 'USA':
          return this.$t('inputMasks.usPhone')
        case 'US':
          return this.$t('inputMasks.usPhone')
        case 'CAN':
          return this.$t('inputMasks.canPhone')
        case 'CA':
          return this.$t('inputMasks.canPhone')
        default:
          return this.$t('inputMasks.usPhone')
      }
    }
  },
  methods: {
    update (key, value) {
      this.$emit('input', { ...this.value, [key]: value })
    },
    validate () {
      return this.$refs[this.$options.name].validate()
    }
  }
}
</script>

<style scoped>

</style>